import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { Box, Paper, Tabs, Tab } from "@material-ui/core";
import Select from "react-select";
import { GroupRounded } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  overflow: {
    height: "calc(100% - 220px)",
    width: "350px",
    overflowY: "scroll",
    overflowX: "hidden",
    top: "127px",
    left: "0",
    position: "absolute",
    borderRadius: 0,
    [theme.breakpoints.down("md")]: {
      width: "calc(100vw - 100px)",
      left: "5px",
    },
  },
  overflownodata: {
    height: "calc(100% - 220px)",
    width: "350px",
    overflowY: "hidden",
    overflowX: "hidden",
    top: "127px",
    left: "0",
    position: "absolute",
    borderRadius: 0,
    [theme.breakpoints.down("md")]: {
      width: "calc(100vw - 100px)",
      left: "5px",
    },
  },
  overFlow2: {
    height: "calc(100% - 65px)",
    width: "350px",
    // overflowX: "hidden",
    top: "150px",
    right: "40px",
    position: "absolute",
    borderRadius: 0,
    [theme.breakpoints.down("md")]: {
      top: "1260px",
      width: "calc(100vw - 100px)",
      height: "500px",
      left: "5px",
    },
  },

  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
    fontWeight: "normal",
    // position: 'absolute !important',
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
  },
  root: {
    width: "350px",
    backgroundColor: theme.palette.background.paper,
    position: "static",
    height: "100%",
  },
  inline: {
    display: "inline",
  },
  objectFit: {
    objectFit: "contain",
  },
  unreadBox: {
    height: "30px",
    width: "30px",
    borderRadius: "50%",
    backgroundColor: "#b499c7",
    color: "white",
    fontSize: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    right: "25px",
    top: "50%",
    transform: "translateY(-50%)",
  },
  smallText: {
    [theme.breakpoints.down("md")]: {
      width: "150px",
    },
  },
  tab: {
    minWidth: "none",
    fontSize: "16px",
    padding: 0,
  },
  tabContainer: {
    background: "white",
    width: "100%",
    position: "sticky",
    top: 0,
    left: 0,
    zIndex: 10,
  },
}));

export default function AlignItemsList(props) {
  const classes = useStyles();
  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const [curTab, setCurTab] = useState(0);
  const [datumid, setdatumid] = useState("");

  const removeFirstItem = (arr, label) => {
    let newArr = arr?.filter((item, index) => true);
    newArr?.unshift({ value: "", label: label });
    return newArr;
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <div className={classes.overFlow2}>
      <ListItem
        alignItems="center"
        style={{
          width: "100%",
          backgroundColor: "#6f59a6",
          color: "white",
          fontFamily: "Montserrat",
          fontWeight: "bold",
          position: "absolute",
          top: 0,
          left: 0,
          height: "71px",
        }}
      >
        <ListItemText
          primary={
            <>
              <Typography
                style={{
                  fontSize: "1rem",
                  fontFamily: "Montserrat",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                Start New Conversation
              </Typography>
            </>
          }
          secondary={
            <>
              {curTab === 0 && (
                <Typography
                  style={{
                    fontSize: "12px",
                    fontFamily: "Montserrat",
                    color: "white",
                  }}
                >
                  TOTAL STARTUPS: {props.newMenu?.length}
                </Typography>
              )}
              {curTab === 1 && (
                <Typography
                  style={{
                    fontSize: "12px",
                    fontFamily: "Montserrat",
                    color: "white",
                  }}
                >
                  TOTAL MENTORS: 0
                </Typography>
              )}
              {curTab === 2 && (
                <Typography
                  style={{
                    fontSize: "12px",
                    fontFamily: "Montserrat",
                    color: "white",
                  }}
                >
                  TOTAL COHORTS: {props.cohortNamesList?.length}
                </Typography>
              )}
            </>
          }
        />
      </ListItem>
      <ListItem
        alignItems="center"
        style={{
          width: "100%",
          backgroundColor: "#6f59a6",
          color: "white",
          fontFamily: "Montserrat",
          fontWeight: "bold",
          position: "absolute",
          top: 70,
          left: 0,
          zIndex: 100,
        }}
      >
        {curTab === 0 && (
          <Select
            className={classes.select}
            placeholder={props.isCohort ? "Search Startup" : "Search"}
            options={removeFirstItem(
              props?.newMenu?.map((item) => ({
                value: item.id,
                label: item.startup?.organization_name,
              })),
              "Select Startup"
            )}
            onChange={(selected) => {
              props.setNewChatMode(true);
              const requiredObj = props.newMenu?.find(
                (item) => item.id === selected.value
              );
              props.setActiveChat({
                apartyId: value?.id,
                bpartyId: requiredObj?.startupId,
                bpartyImage: requiredObj?.startup?.image,
                bpartyName: requiredObj?.startup?.organization_name,
              });
              props.setChatData(null);
            }}
            styles={{
              menu: (styles) => {
                return {
                  ...styles,
                  width: "auto",
                  zIndex: 1000,
                };
              },
              option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                  ...styles,
                  backgroundColor: isSelected
                    ? "#b499c7"
                    : isFocused
                    ? "#e4d7ee"
                    : "white",
                  color: isSelected ? "white" : "black",
                  cursor: isDisabled ? "not-allowed" : "default",
                };
              },
            }}
          />
        )}
        {curTab === 1 && (
          <Select
            className={classes.select}
            placeholder={props.isCohort ? "Search Startup" : "Search"}
            options={removeFirstItem(
              props?.newMenu?.map((item) => ({
                value: item.id,
                label: item.startup?.organization_name,
              })),
              "Select Mentor"
            )}
            onChange={(selected) => {
              props.setNewChatMode(true);
              const requiredObj = props.newMenu?.find(
                (item) => item.id === selected.value
              );
              props.setActiveChat({
                apartyId: value?.id,
                bpartyId: requiredObj?.startupId,
                bpartyImage: requiredObj?.startup?.image,
                bpartyName: requiredObj?.startup?.organization_name,
              });
              props.setChatData(null);
            }}
            styles={{
              menu: (styles) => {
                return {
                  ...styles,
                  width: "auto",
                  zIndex: 1000,
                };
              },
              option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                  ...styles,
                  backgroundColor: isSelected
                    ? "#b499c7"
                    : isFocused
                    ? "#e4d7ee"
                    : "white",
                  color: isSelected ? "white" : "black",
                  cursor: isDisabled ? "not-allowed" : "default",
                };
              },
            }}
          />
        )}
        {curTab === 2 && (
          <Select
            className={classes.select}
            placeholder={props.isCohort ? "Search Startup" : "Search"}
            options={removeFirstItem(
              props?.cohortNamesList?.map((item) => ({
                value: item.id,
                label: item?.name,
              })),
              "Select Cohort"
            )}
            onChange={(selected) => {
              props.setNewChatMode(true);
              const requiredObj = props.cohortNamesList?.find(
                (item) => item.id === selected.value
              );
              props.setActiveChat({
                apartyId: value?.id,
                bpartyId: requiredObj?.id,
                bpartyImage: requiredObj?.image,
                bpartyName: requiredObj?.name,
              });
              props.setChatData(null);
            }}
            styles={{
              menu: (styles) => {
                return {
                  ...styles,
                  width: "auto",
                  zIndex: 1000,
                };
              },
              option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                  ...styles,
                  backgroundColor: isSelected
                    ? "#b499c7"
                    : isFocused
                    ? "#e4d7ee"
                    : "white",
                  color: isSelected ? "white" : "black",
                  cursor: isDisabled ? "not-allowed" : "default",
                };
              },
            }}
          />
        )}
      </ListItem>
      <Paper
        className={
          curTab === 0 && props.newMenu?.length > 0
            ? classes.overflow
            : curTab === 2 && props.cohortNamesList?.length > 0
            ? classes.overflow
            : classes.overflownodata
        }
      >
        {props.isCohort && (
          <div className={classes.tabContainer}>
            <Tabs
              value={curTab}
              onChange={(event, number) => {
                setCurTab(number);
              }}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
            >
              <Tab
                style={{ minWidth: 0, width: "33%" }}
                label="STARTUP"
                // id={`full-width-tab-0`}
                // aria-controls={`full-width-tabpanel-0`}
                className={classes.tab}
                onClick={() => {
                  props.setclickedGroupName(false);
                }}
              />
              <Tab
                label="MENTOR"
                style={{ minWidth: 0, width: "33%" }}
                // id={`full-width-tab-1`}
                // aria-controls={`full-width-tabpanel-1`}
                className={classes.tab}
                onClick={() => {
                  props.setclickedGroupName(false);
                }}
              />
              <Tab
                label={
                  props.cohortNamesList?.length > 0
                    ? `COHORT (${props.cohortNamesList?.length})`
                    : `COHORT`
                  // <span>
                  //   <span>{`COHORT`}</span>{" "}
                  //   <span
                  //     style={{
                  //       background: "#6f59a6",
                  //       borderRadius: "12px",
                  //       padding: "5px",
                  //       color: "black",
                  //       fontSize: "12px",
                  //       display:
                  //         props.cohortNamesList?.length > 0 ? "unset" : "none",
                  //     }}
                  //   >
                  //     {props.cohortNamesList?.length}
                  //   </span>
                  // </span>
                }
                // icon={<p>{props.cohortNamesList?.length}</p>}
                style={{ minWidth: 0, width: "33%" }}
                // id={`full-width-tab-2`}
                // aria-controls={`full-width-tabpanel-2`}
                className={classes.tab}
                onClick={() => {
                  props.setClickedTab(true);
                  props.setclickedGroupName(false);
                  props.setcohortclickedName(true);
                  props.setindividualclickedName(false);
                }}
              />
            </Tabs>
          </div>
        )}
        <List className={classes.root} style={{ width: "100%" }}>
          {curTab === 0 &&
            (props.newMenu?.length > 0 ? (
              props.newMenu?.map((datum) => (
                <>
                  <ListItem
                    button
                    onClick={() => {
                      props.setclickedGroupName(false);
                      const value = JSON.parse(
                        localStorage.getItem("SavedLoggedInData")
                      );
                      props.setNewChatMode(true);
                      props.setActiveChat({
                        apartyId: value?.id,
                        bpartyId: datum?.startupId,
                        bpartyImage: datum?.startup?.image,
                        bpartyName: datum?.startup?.organization_name,
                      });
                      props.setChatData(null);
                    }}
                    alignItems="center"
                  >
                    <ListItemAvatar>
                      <Avatar
                        classes={{
                          img: classes.objectFit,
                        }}
                        src={datum?.startup?.image}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography className={classes.smallText}>
                          {datum?.startup?.organization_name}
                        </Typography>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <p>No Startups Available</p>
              </div>
            ))}
          {curTab === 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <p>No Mentors Available</p>
            </div>
          )}
          {curTab === 2 &&
            (props.cohortNamesList?.length > 0 ? (
              props.cohortNamesList?.map((datum) => (
                <>
                  <ListItem
                    button
                    onClick={() => {
                      props.setClickedTab(true);
                      props.setindividualclickedName(false);
                      props.setclickedGroupName(false);
                      props.setcohortclickedName(true);
                      props.setnewcohortname(datum?.name);
                      props.setcohortidcohort(datum?.id);
                      props.setcohortimage(datum?.image);
                      const value = JSON.parse(
                        localStorage.getItem("SavedLoggedInData")
                      );
                      props.setNewChatMode(true);
                      props.setActiveChat({
                        apartyId: value?.id,
                        bpartyId: datum?.id,
                        bpartyImage: datum?.image,
                        bpartyName: datum?.name,
                        mode: "COHORT",
                      });
                      props.setChatData(null);
                      props.onConversationClick(datum?.id, datum);
                      props.setdatumidconvo(datum?.id);
                      props.setdatumidgroup("");
                    }}
                    alignItems="center"
                    style={{
                      backgroundColor:
                        props.datumidconvo === datum?.id
                          ? "rgba(0,0,0,0.1)"
                          : "",
                    }}
                  >
                    <ListItemAvatar>
                      {/* <Avatar
                  classes={{
                    img: classes.objectFit,
                  }}
                  src={datum?.image}
                /> */}
                      <Avatar>
                        <GroupRounded />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography className={classes.smallText}>
                          {datum?.name}
                        </Typography>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <p>No Cohorts Available</p>
              </div>
            ))}
        </List>
      </Paper>
    </div>
  );
}
